import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Alag se banayi gayi JSON translation files ko import kiya
import translationEN from './locales/en/translation.json';
import translationES from './locales/es/translation.json';
import translationFA from './locales/fa/translation.json';
import translationTR from './locales/tr/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  en: { translation: translationEN },
  es: { translation: translationES },
  fa: { translation: translationFA },
  tr: { translation: translationTR },
  ar: { translation: translationAR }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false 
    }
  });

export default i18n;